module.exports = __webpack_public_path__ + "img/xinwen11.4eb7ef5f.jpg";